import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=75c0716a&scoped=true&"
import script from "./FeedbackModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=75c0716a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0716a",
  null
  
)

export default component.exports